import { render, staticRenderFns } from "./NewShoppingCartBack.vue?vue&type=template&id=9d547634&scoped=true&"
import script from "./NewShoppingCartBack.vue?vue&type=script&lang=js&"
export * from "./NewShoppingCartBack.vue?vue&type=script&lang=js&"
import style0 from "./NewShoppingCartBack.vue?vue&type=style&index=0&id=9d547634&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d547634",
  null
  
)

export default component.exports